module.exports = __webpack_public_path__ + "img/logo_12.83f54b58.jpg";